export const COOKIE_SESSION = 'session';
export const COOKIE_EMAIL_VERIFIED = 'email-verified';

export const LS_DISPLAY_NAME_PROMPT = 'requestDisplayName_';
